<template>
    <div class="search-form px-2">
        <div class="col-sm-12 search-form-title mx-2">
            <font-awesome-icon icon="search" />
            {{ $t('menu.mixed_waste_bins') }}
        </div>
        <form
            @submit.prevent="onSubmit"
            @reset="onReset"
        >
            <contract-filter
                ref="filter"
                :user="user"
                :show-only-my-contracts-option="true"
                @contract-set="setContract"
                @company-set="companySet"
            />
            <div class="row nopads">
                <div class="col-sm-3">
                    <span class="span-title">{{ $t('mixed_waste_bins.waste_bin_type') }}</span>
                    <select
                        v-model="wasteBinType"
                        class="form-select form-select-sm"
                    >
                        <option :value="null">
                            {{ $t('mixed_waste_bins.choose_waste_bin_type') }}
                        </option>
                        <option
                            v-for="item in getMixedWasteBinWasteType()"
                            :key="item.value"
                            :value="item.value"
                        >
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-3">
                    <span class="span-title">{{ $t('observation_list.status') }}</span>
                    <select
                        v-model="status"
                        class="form-select form-select-sm title"
                    >
                        <option
                            v-for="option in timeFilters"
                            :key="option.value"
                            :value="option.value"
                        >
                            {{ option.text }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-12 px-2 pb-2 d-flex justify-content-end">
                <button
                    type="submit"
                    class="btn btn-primary  form-button"
                >
                    {{ $t('ins_report.search') }}
                </button>
                <button
                    type="reset"
                    class="btn btn-danger  form-button"
                >
                    {{ $t('ins_report.clear') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import ContractFilter from '../contract/ContractFilter'
import {timeUtils} from '../mixins/TimeUtils'
import {restApi} from "@/components/mixins/RestApiMixin"
import {mixedWasteBinHelper} from "@/components/mixins/MixedWasteBinMixin";
const STATUS = {
    ALL: 0,
    ACTIVE: 1,
    DELETED: 2,
}

const INIT_STATUS = STATUS.ALL
export default {
    name: 'MixedWasteBinsSearch',
    components: {ContractFilter},
    mixins: [restApi,mixedWasteBinHelper ],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            contract: null,
            company: null,
            status: 0,
            wasteBinType: null,
            timeFilters: [
                {
                    text: this.$t("mixed_waste_bins.all"),
                    value: STATUS.ALL,
                },
                {
                    text: this.$t("mixed_waste_bins.is_not_deleted"),
                    value: STATUS.ACTIVE,
                },
                {
                    text: this.$t("mixed_waste_bins.is_deleted"),
                    value: STATUS.DELETED,
                },
            ],
        }
    },
    mounted() {

    },
    methods: {
        setContract: function (contract) {
            this.contract = contract
        },
        companySet: function (company) {
            this.company = company
        },
        onSubmit: function () {
            let params = {}
            let type = []
            if (this.wasteBinType) {
                type.push(this.wasteBinType)
                params.type = type
            }
            if (this.status !== 0) {
                params.status = this.status
            }
            if (this.contract) {
                params.contractId = this.contract
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.contract = null
            this.status = INIT_STATUS
            this.$refs.filter.resetData()
            this.$emit('clear')
        },
        handleSearch: function (response) {
            this.loading = false
        },
    }
}
</script>
